"use client"

import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox"
import { Check, Minus } from "lucide-react"

import { cn } from "@/lib/utils"

function Checkbox({
  className,
  indeterminate,
  ...props
}: CheckboxPrimitive.Root.Props) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      indeterminate={indeterminate}
      className={cn(
        "peer inline-flex size-4 shrink-0 items-center justify-center rounded-[5px] border border-neutral-300 bg-white shadow-xs transition-colors outline-none dark:border-neutral-600 dark:bg-neutral-900",
        "hover:border-neutral-400 dark:hover:border-neutral-500",
        "focus-visible:border-neutral-900 focus-visible:ring-3 focus-visible:ring-neutral-900/15 dark:focus-visible:border-neutral-100 dark:focus-visible:ring-neutral-100/20",
        "data-[checked]:border-neutral-900 data-[checked]:bg-neutral-900 data-[checked]:text-white dark:data-[checked]:border-neutral-100 dark:data-[checked]:bg-neutral-100 dark:data-[checked]:text-neutral-900",
        "data-[indeterminate]:border-neutral-900 data-[indeterminate]:bg-neutral-900 data-[indeterminate]:text-white dark:data-[indeterminate]:border-neutral-100 dark:data-[indeterminate]:bg-neutral-100 dark:data-[indeterminate]:text-neutral-900",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current"
      >
        {indeterminate ? (
          <Minus className="size-3.5" strokeWidth={3} />
        ) : (
          <Check className="size-3.5" strokeWidth={3} />
        )}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
